import yup from '../../../config/yup';

export const infosilemReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('infosilemReader'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    rootUrl: yup.string().required('Root URL is required'),
    username: yup.string().required('Username is required'),
    password: yup.string().required('Password is required'),
    workspace: yup.string().required('Workspace is required'),
    path: yup.string().required('Path is required'),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .required('HTTP Method is required'),
    headers: yup.string(),
    headersJson: yup.string(),
    acceptInvalidCerts: yup.boolean(),
    body: yup.string(),
  }),
});
